module.exports = __webpack_public_path__ + "bg-footer.e9e6882f58f364300f4c.png";


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/assets/images/bg-footer.png
// module id = ../../../../../src/assets/images/bg-footer.png
// module chunks = main